import {PayloadAction} from "../payload-action.interface";
import {LocationEntity} from "./location.entity";
import {LocationActions} from "./location.actions";

export function LocationReducer(state: Array<LocationEntity> = [], action: PayloadAction) {
  let newState;

  switch (action.type) {
    case LocationActions.REMOVE:
      return removeLocation(state, action.payload);
    case LocationActions.ADD:
    case LocationActions.SET:
      newState = removeLocation(state, action.payload._id);
      return addLocation(newState, action.payload);
    case LocationActions.ADD_ALL:
      return [...action.payload];
    default:
      return state;
  }
}

function addLocation(state: Array<LocationEntity>, location: LocationEntity): Array<LocationEntity> {
  return [...state, location];
}

function removeLocation(state: Array<LocationEntity>, id: string): Array<LocationEntity> {
  return state.filter((location) => location._id !== id);
}



// WEBPACK FOOTER //
// ./src/store/location/location.reducer.ts